const sw = {
    time: "Tid",
    approval: "Godkännande",
    expenses: "Utgifter",
    tasks: "Uppgifter",
    reporting: "Rapportering",
    overview: "Översikt",
    timeline: "tidslinjen",
};

export default sw;
